// Student lifecycle — shared labels, colours and access-flag metadata for the admin UI.
// One definition so the filter dropdown, the detail badge and the portal-access panel
// cannot drift apart.

export const LIFECYCLE_OPTIONS = [
  { value: "", label: "Currently studying (default)" },
  { value: "active", label: "Active" },
  { value: "detained", label: "Detained" },
  { value: "dropped", label: "Dropped out" },
  { value: "cancelled", label: "Admission cancelled" },
  { value: "transferred", label: "Transferred" },
  { value: "graduated", label: "Graduated" },
];

// Values sent to the admin student endpoints as ?gender=. The server matches them
// case-insensitively and treats "Other" as also covering the stored plural "Others",
// so these four labels cover every spelling in the data.
export const GENDER_OPTIONS = [
  { value: "", label: "All genders" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const DATA_FLAG_OPTIONS = [
  { value: "", label: "Any" },
  { value: "graduated_with_backlogs", label: "Graduated — pending subjects" },
];

export const LIFECYCLE_LABELS = {
  active: "Active",
  detained: "Detained",
  dropped: "Dropped out",
  cancelled: "Admission cancelled",
  transferred: "Transferred",
  graduated: "Graduated",
};

export const LIFECYCLE_BADGE_CLASSES = {
  active: "bg-green-100 text-green-800",
  detained: "bg-amber-100 text-amber-800",
  dropped: "bg-red-100 text-red-800",
  cancelled: "bg-gray-200 text-gray-700",
  transferred: "bg-blue-100 text-blue-800",
  graduated: "bg-indigo-100 text-indigo-800",
};

export const lifecycleLabel = (student) => {
  const lc = student?.lifecycleStatus;
  if (lc) return LIFECYCLE_LABELS[lc] || lc;
  // Records not yet through the lifecycle backfill still carry only the legacy status.
  if (student?.status === "active") return "Active";
  if (student?.status === "graduated") return "Graduated";
  if (student?.status === "inactive") return "Inactive (legacy)";
  return "Unknown";
};

export const lifecycleBadgeClass = (student) =>
  LIFECYCLE_BADGE_CLASSES[student?.lifecycleStatus] || "bg-gray-100 text-gray-700";

// The order here is the order shown in the Portal Access panel.
export const PORTAL_ACCESS_FIELDS = [
  { key: "canLogin", label: "Can log in", desc: "Sign in to the student portal at all" },
  { key: "canResetPassword", label: "Can reset password", desc: "Use forgot-password to recover access" },
  { key: "canViewResults", label: "Can view results", desc: "See their own marks and results" },
  { key: "canViewNotes", label: "Can view notes", desc: "Open class notes for their batch" },
  { key: "canSelectElectives", label: "Can select electives", desc: "Take part in elective selection" },
  {
    key: "canApplyAtkt",
    label: "Can apply for ATKT",
    desc: "Submit ATKT forms — still requires outstanding backlogs",
  },
  { key: "canPayFees", label: "Can pay fees", desc: "Access fee payment pages" },
];
